// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Mulish-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Mulish-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Mulish-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Mulish-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Mulish-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Mulish-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Mulish-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Mulish-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Mulish-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Mulish-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Mulish-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/Mulish-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/fonts/Mulish-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/fonts/Mulish-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/fonts/Mulish-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/fonts/Mulish-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/fonts/Mulish-SemiBoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/fonts/Mulish-SemiBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/fonts/Mulish-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/fonts/Mulish-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/fonts/Mulish-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/fonts/Mulish-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/fonts/Mulish-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/fonts/Mulish-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/fonts/Mulish-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../assets/fonts/Mulish-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../assets/fonts/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../assets/fonts/Mulish-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../assets/fonts/Mulish-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../assets/fonts/Mulish-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../assets/fonts/Mulish-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../assets/fonts/Mulish-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../assets/fonts/Mulish-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../assets/fonts/Mulish-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../assets/fonts/Mulish-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../assets/fonts/Mulish-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../assets/fonts/raleway-v13-latin-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../assets/fonts/raleway-v13-latin-300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../assets/fonts/raleway-v13-latin-300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../assets/fonts/raleway-v13-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../assets/fonts/raleway-v13-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../assets/fonts/raleway-v13-latin-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../assets/fonts/raleway-v13-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../assets/fonts/raleway-v13-latin-500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../assets/fonts/raleway-v13-latin-500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../assets/fonts/raleway-v13-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../assets/fonts/raleway-v13-latin-600.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../assets/fonts/raleway-v13-latin-600.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../assets/fonts/raleway-v13-latin-800.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../assets/fonts/raleway-v13-latin-800.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../assets/fonts/raleway-v13-latin-800.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../assets/fonts/montserrat-v14-latin-300.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../assets/fonts/montserrat-v14-latin-300.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../assets/fonts/montserrat-v14-latin-300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../assets/fonts/montserrat-v18-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../assets/fonts/montserrat-v18-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../assets/fonts/montserrat-v18-latin-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../assets/fonts/montserrat-v18-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../assets/fonts/montserrat-v18-latin-500.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../assets/fonts/montserrat-v18-latin-500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../assets/fonts/montserrat-v18-latin-600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../assets/fonts/montserrat-v18-latin-600.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../assets/fonts/montserrat-v18-latin-600.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../assets/fonts/montserrat-v18-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../assets/fonts/montserrat-v18-latin-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../assets/fonts/montserrat-v18-latin-700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../assets/fonts/montserrat-v18-latin-800.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../assets/fonts/montserrat-v18-latin-800.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../assets/fonts/montserrat-v18-latin-800.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../assets/fonts/montserrat-v18-latin-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../assets/fonts/montserrat-v18-latin-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../assets/fonts/montserrat-v18-latin-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../assets/fonts/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../assets/fonts/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("../assets/fonts/Lato-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("../assets/fonts/Lato-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("../assets/fonts/Poppins-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("../assets/fonts/Poppins-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("../assets/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("../assets/fonts/OpenSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("../assets/fonts/OpenSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("../assets/fonts/OpenSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("../assets/fonts/Carlito-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("../assets/fonts/Carlito-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("../assets/fonts/Carlito-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("../assets/fonts/ArialMTStd-LightCond.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("../assets/fonts/ArialMTStd-LightCond.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("../assets/fonts/ArialMTStd-LightCond.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("../assets/fonts/ArialMTStd-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("../assets/fonts/ArialMTStd-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("../assets/fonts/ArialMTStd-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("../assets/fonts/relative-bold-pro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("../assets/fonts/relative-bold-pro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("../assets/fonts/relative-bold-pro.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("../assets/fonts/relative-book-pro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("../assets/fonts/relative-book-pro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("../assets/fonts/relative-book-pro.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("../assets/fonts/relative-medium-pro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("../assets/fonts/relative-medium-pro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("../assets/fonts/relative-medium-pro.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("../assets/fonts/relative-mono-11-pitch-pro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("../assets/fonts/relative-mono-11-pitch-pro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("../assets/fonts/relative-mono-11-pitch-pro.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("../assets/fonts/Cabin-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("../assets/fonts/Cabin-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("../assets/fonts/Cabin-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("../assets/fonts/Cabin-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("../assets/fonts/Cabin-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("../assets/fonts/Cabin-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("../assets/fonts/Cabin-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("../assets/fonts/Cabin-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("../assets/fonts/Cabin-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("../assets/fonts/Cabin-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("../assets/fonts/Cabin-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("../assets/fonts/Cabin-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.18 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root {
  --inherit: inherit;
  --current: currentColor;
  --transparent: transparent;
  --black: #000;
  --white: #fff;
  --flexi-primary-color: #2CB4AD;
  --flexi-text: #0E1214;
  --flexi-border: #E5E7EB;
  --flexi-select-active: #f5f5f5;
}

body {
  color: var(--flexi-text);
}

label {
  color: var(--flexi-text);
}

:root {
  --flexi-lightblue: #98CBE2;
  --flexi-logo: #262959;
  --flexi-grey: #878F8F;
  --flexi-red: #F36572;
  --flexi-lime: #8FDD69;
  --flexi-valid: #2CB469;
  --flexi-warning: #F09103;
  --flexi-warning-toaster: #F9E9D1;
  --flexi-valid-toaster: #D4F0E1;
  --flexi-placeholder: #CECACA;
  --flexi-blue: #40A9FF;
  --flexi-col-table: #F2F2F2;
  --flexi-error-toaster: #FFE7E2;
  --flexi-error: #F44D29;
  --flexi-info-toaster: #E0F6F5;
  --flexi-blue-bg: #F3FAFD;
  --flexi-super-admin: #E5EDFD;
  --flexi-super-admin-bg: #6C96F1;
  --flexi-admin: #7EA2F2;
  --flexi-admin-bg: #E6EDFB;
  --flexi-offer-editor: #27AA58;
  --flexi-offer-editor-bg: #E6F3EB;
  --flexi-qa: #FF8D74;
  --flexi-qa-bg: #FFD7CE;
  --flexi-regular: #9AA0A0;
  --flexi-regular-bg: #DADADA;
  --flexi-history-page-bg: #F1FAFE;
  --flexi-history-widget: #1A9B8C;
  --flexi-history-widget-bg: #E6F6F4;
  --flexi-history-widget-border: #A8DED8;
  --flexi-history-section: #7C3AED;
  --flexi-history-section-bg: #EDE9FB;
  --flexi-history-section-border: #C4B5F8;
  --flexi-history-document: #2563EB;
  --flexi-history-document-bg: #EFF6FF;
  --flexi-history-document-border: #BFDBFE;
  --flexi-history-placement: #FA8C16;
  --flexi-history-placement-bg: #FEF3C7;
  --flexi-history-error: #FF785A;
  --flexi-history-milestone: #3398F6;
  --flexi-history-highlight: #FFF185;
  --flexi-bg-day-timeline: #F8FAFC;
}
  svg {
    vertical-align: unset;
  }
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 0px) {

  .\\!container {
    max-width: 0px !important;
  }

  .container {
    max-width: 0px;
  }
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1520px) {

  .\\!container {
    max-width: 1520px !important;
  }

  .container {
    max-width: 1520px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-36 {
  bottom: -9rem;
}
.-left-2\\.5 {
  left: -0.625rem;
}
.-top-36 {
  top: -9rem;
}
.-top-\\[23px\\] {
  top: -23px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-12 {
  bottom: 3rem;
}
.bottom-\\[3\\.900rem\\] {
  bottom: 3.900rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-210px {
  left: 210px;
}
.left-400px {
  left: 400px;
}
.left-\\[240px\\] {
  left: 240px;
}
.right-0 {
  right: 0px;
}
.right-210px {
  right: 210px;
}
.right-400px {
  right: 400px;
}
.right-8 {
  right: 2rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-6 {
  top: 1.5rem;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[5\\] {
  z-index: 5;
}
.z-auto {
  z-index: auto;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.float-right {
  float: right;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-auto {
  margin: auto;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.\\!mb-1 {
  margin-bottom: 0.25rem !important;
}
.\\!mb-3 {
  margin-bottom: 0.75rem !important;
}
.\\!mb-4 {
  margin-bottom: 1rem !important;
}
.\\!mb-5 {
  margin-bottom: 1.25rem !important;
}
.\\!mb-7 {
  margin-bottom: 1.75rem !important;
}
.\\!mr-1\\.5 {
  margin-right: 0.375rem !important;
}
.\\!mr-2 {
  margin-right: 0.5rem !important;
}
.\\!mt-0 {
  margin-top: 0px !important;
}
.\\!mt-10 {
  margin-top: 2.5rem !important;
}
.\\!mt-2 {
  margin-top: 0.5rem !important;
}
.\\!mt-3 {
  margin-top: 0.75rem !important;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-32 {
  margin-bottom: 8rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-12 {
  margin-left: 3rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[256px\\] {
  margin-left: 256px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-10px {
  margin-right: 10px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-5px {
  margin-right: 5px;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-11 {
  margin-top: 2.75rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-250px {
  margin-top: 250px;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-1\\.2rem\\] {
  margin-top: -1.2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.\\!inline-flex {
  display: inline-flex !important;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.\\!contents {
  display: contents !important;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.\\!h-11 {
  height: 2.75rem !important;
}
.\\!h-3\\.5 {
  height: 0.875rem !important;
}
.\\!h-9 {
  height: 2.25rem !important;
}
.\\!h-\\[83vh\\] {
  height: 83vh !important;
}
.\\!h-\\[95vh\\] {
  height: 95vh !important;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-1000px {
  height: 1000px;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-18px {
  height: 18px;
}
.h-20px {
  height: 20px;
}
.h-25px {
  height: 25px;
}
.h-3 {
  height: 0.75rem;
}
.h-30px {
  height: 30px;
}
.h-32px {
  height: 32px;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-50px {
  height: 50px;
}
.h-520px {
  height: 520px;
}
.h-582px {
  height: 582px;
}
.h-6 {
  height: 1.5rem;
}
.h-750px {
  height: 750px;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-910px {
  height: 910px;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[95px\\] {
  height: 95px;
}
.h-\\[calc\\(100\\%-50px\\)\\] {
  height: calc(100% - 50px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-125px {
  max-height: 125px;
}
.max-h-250px {
  max-height: 250px;
}
.max-h-450px {
  max-height: 450px;
}
.max-h-910px {
  max-height: 910px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-full {
  max-height: 100%;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-50px {
  min-height: 50px;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-11 {
  width: 2.75rem !important;
}
.\\!w-20 {
  width: 5rem !important;
}
.\\!w-3\\.5 {
  width: 0.875rem !important;
}
.\\!w-3\\/4 {
  width: 75% !important;
}
.\\!w-400px {
  width: 400px !important;
}
.\\!w-600px {
  width: 600px !important;
}
.\\!w-72 {
  width: 18rem !important;
}
.\\!w-\\[200px\\] {
  width: 200px !important;
}
.\\!w-\\[400px\\] {
  width: 400px !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-120px {
  width: 120px;
}
.w-150px {
  width: 150px;
}
.w-18px {
  width: 18px;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20px {
  width: 20px;
}
.w-210px {
  width: 210px;
}
.w-24 {
  width: 6rem;
}
.w-250px {
  width: 250px;
}
.w-25px {
  width: 25px;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-300px {
  width: 300px;
}
.w-30px {
  width: 30px;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-400px {
  width: 400px;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-60 {
  width: 15rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-800px {
  width: 800px;
}
.w-9 {
  width: 2.25rem;
}
.w-90px {
  width: 90px;
}
.w-\\[256px\\] {
  width: 256px;
}
.w-\\[608px\\] {
  width: 608px;
}
.w-\\[calc\\(100\\%-256px\\)\\] {
  width: calc(100% - 256px);
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.\\!max-w-full {
  max-width: 100% !important;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-full {
  max-width: 100%;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!cursor-default {
  cursor: default !important;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.resize {
  resize: both;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[80px_80px_1fr_110px_140px_140px\\] {
  grid-template-columns: 80px 80px 1fr 110px 140px 140px;
}
.\\!flex-row {
  flex-direction: row !important;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-between {
  place-content: space-between;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-0 {
  -moz-column-gap: 0px;
       column-gap: 0px;
}
.gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(5rem * var(--tw-space-x-reverse));
  margin-left: calc(5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.\\!rounded-sm {
  border-radius: 0.125rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.\\!rounded-l-2xl {
  border-top-left-radius: 1rem !important;
  border-bottom-left-radius: 1rem !important;
}
.\\!rounded-r-2xl {
  border-top-right-radius: 1rem !important;
  border-bottom-right-radius: 1rem !important;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.\\!border-2 {
  border-width: 2px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-1 {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.\\!border-r-0 {
  border-right-width: 0px !important;
}
.border-b-1 {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-1 {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-flexi-border {
  --tw-border-opacity: 1 !important;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-flexi-primary-color {
  --tw-border-opacity: 1 !important;
  border-color: rgb(44 180 173 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-flexi-select-active {
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 245 245 / var(--tw-border-opacity, 1)) !important;
}
.border-flexi-border {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-flexi-history-document {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-flexi-history-document-bg {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity, 1));
}
.border-flexi-history-document-border {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-flexi-history-error {
  --tw-border-opacity: 1;
  border-color: rgb(255 120 90 / var(--tw-border-opacity, 1));
}
.border-flexi-history-highlight {
  --tw-border-opacity: 1;
  border-color: rgb(255 241 133 / var(--tw-border-opacity, 1));
}
.border-flexi-history-milestone {
  --tw-border-opacity: 1;
  border-color: rgb(51 152 246 / var(--tw-border-opacity, 1));
}
.border-flexi-history-placement {
  --tw-border-opacity: 1;
  border-color: rgb(250 140 22 / var(--tw-border-opacity, 1));
}
.border-flexi-history-placement-bg {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-flexi-history-section {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-flexi-history-section-bg {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 251 / var(--tw-border-opacity, 1));
}
.border-flexi-history-section-border {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 248 / var(--tw-border-opacity, 1));
}
.border-flexi-history-widget {
  --tw-border-opacity: 1;
  border-color: rgb(26 155 140 / var(--tw-border-opacity, 1));
}
.border-flexi-history-widget-bg {
  --tw-border-opacity: 1;
  border-color: rgb(230 246 244 / var(--tw-border-opacity, 1));
}
.border-flexi-history-widget-border {
  --tw-border-opacity: 1;
  border-color: rgb(168 222 216 / var(--tw-border-opacity, 1));
}
.border-flexi-primary-color {
  --tw-border-opacity: 1;
  border-color: rgb(44 180 173 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.\\!bg-flexi-col-table\\/30 {
  background-color: rgb(242 242 242 / 0.3) !important;
}
.\\!bg-flexi-primary-color {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(44 180 173 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-flexi-select-active {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-flexi-admin {
  --tw-bg-opacity: 1;
  background-color: rgb(126 162 242 / var(--tw-bg-opacity, 1));
}
.bg-flexi-admin-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(230 237 251 / var(--tw-bg-opacity, 1));
}
.bg-flexi-bg-day-timeline {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-flexi-blue-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 253 / var(--tw-bg-opacity, 1));
}
.bg-flexi-col-table {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.bg-flexi-error-toaster {
  --tw-bg-opacity: 1;
  background-color: rgb(255 231 226 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-document {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-document-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-document-border {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-error {
  --tw-bg-opacity: 1;
  background-color: rgb(255 120 90 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 133 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-milestone {
  --tw-bg-opacity: 1;
  background-color: rgb(51 152 246 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-page-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(241 250 254 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-placement {
  --tw-bg-opacity: 1;
  background-color: rgb(250 140 22 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-placement-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-section {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-section-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 251 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-section-border {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 248 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-widget {
  --tw-bg-opacity: 1;
  background-color: rgb(26 155 140 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-widget-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(230 246 244 / var(--tw-bg-opacity, 1));
}
.bg-flexi-history-widget-border {
  --tw-bg-opacity: 1;
  background-color: rgb(168 222 216 / var(--tw-bg-opacity, 1));
}
.bg-flexi-info-toaster {
  --tw-bg-opacity: 1;
  background-color: rgb(224 246 245 / var(--tw-bg-opacity, 1));
}
.bg-flexi-lightblue {
  --tw-bg-opacity: 1;
  background-color: rgb(152 203 226 / var(--tw-bg-opacity, 1));
}
.bg-flexi-lime {
  --tw-bg-opacity: 1;
  background-color: rgb(143 221 105 / var(--tw-bg-opacity, 1));
}
.bg-flexi-offer-editor {
  --tw-bg-opacity: 1;
  background-color: rgb(39 170 88 / var(--tw-bg-opacity, 1));
}
.bg-flexi-offer-editor-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(230 243 235 / var(--tw-bg-opacity, 1));
}
.bg-flexi-primary-color {
  --tw-bg-opacity: 1;
  background-color: rgb(44 180 173 / var(--tw-bg-opacity, 1));
}
.bg-flexi-qa {
  --tw-bg-opacity: 1;
  background-color: rgb(255 141 116 / var(--tw-bg-opacity, 1));
}
.bg-flexi-qa-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(255 215 206 / var(--tw-bg-opacity, 1));
}
.bg-flexi-red {
  --tw-bg-opacity: 1;
  background-color: rgb(243 101 114 / var(--tw-bg-opacity, 1));
}
.bg-flexi-regular {
  --tw-bg-opacity: 1;
  background-color: rgb(154 160 160 / var(--tw-bg-opacity, 1));
}
.bg-flexi-regular-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(218 218 218 / var(--tw-bg-opacity, 1));
}
.bg-flexi-select-active {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-flexi-super-admin {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 253 / var(--tw-bg-opacity, 1));
}
.bg-flexi-super-admin-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(108 150 241 / var(--tw-bg-opacity, 1));
}
.bg-flexi-text {
  --tw-bg-opacity: 1;
  background-color: rgb(14 18 20 / var(--tw-bg-opacity, 1));
}
.bg-flexi-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(240 145 3 / var(--tw-bg-opacity, 1));
}
.bg-flexi-warning-toaster {
  --tw-bg-opacity: 1;
  background-color: rgb(249 233 209 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-12 {
  padding: 3rem !important;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 1px;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-11 {
  padding: 2.75rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[\\.25rem\\] {
  padding: .25rem;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-38px {
  padding-left: 38px;
  padding-right: 38px;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.5px;
  padding-bottom: 0.5px;
}
.py-1 {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pl-\\[25px\\] {
  padding-left: 25px !important;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-1 {
  padding-left: 1px;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pt-1 {
  padding-top: 1px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.\\!text-left {
  text-align: left !important;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.align-text-top {
  vertical-align: text-top;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-\\[18px\\] {
  font-size: 18px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-medium {
  font-size: 13px;
}
.text-regular {
  font-size: 11px;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.leading-\\[100vh\\] {
  line-height: 100vh;
}
.\\!text-flexi-blue {
  --tw-text-opacity: 1 !important;
  color: rgb(64 169 255 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-flexi-error {
  --tw-text-opacity: 1 !important;
  color: rgb(244 77 41 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-flexi-grey {
  --tw-text-opacity: 1 !important;
  color: rgb(135 143 143 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-flexi-primary-color {
  --tw-text-opacity: 1 !important;
  color: rgb(44 180 173 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-flexi-text {
  --tw-text-opacity: 1 !important;
  color: rgb(14 18 20 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-flexi-valid {
  --tw-text-opacity: 1 !important;
  color: rgb(44 180 105 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-flexi-admin {
  --tw-text-opacity: 1;
  color: rgb(126 162 242 / var(--tw-text-opacity, 1));
}
.text-flexi-admin-bg {
  --tw-text-opacity: 1;
  color: rgb(230 237 251 / var(--tw-text-opacity, 1));
}
.text-flexi-error {
  --tw-text-opacity: 1;
  color: rgb(244 77 41 / var(--tw-text-opacity, 1));
}
.text-flexi-grey {
  --tw-text-opacity: 1;
  color: rgb(135 143 143 / var(--tw-text-opacity, 1));
}
.text-flexi-history-document {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-flexi-history-document-bg {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity, 1));
}
.text-flexi-history-document-border {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-flexi-history-error {
  --tw-text-opacity: 1;
  color: rgb(255 120 90 / var(--tw-text-opacity, 1));
}
.text-flexi-history-highlight {
  --tw-text-opacity: 1;
  color: rgb(255 241 133 / var(--tw-text-opacity, 1));
}
.text-flexi-history-milestone {
  --tw-text-opacity: 1;
  color: rgb(51 152 246 / var(--tw-text-opacity, 1));
}
.text-flexi-history-placement {
  --tw-text-opacity: 1;
  color: rgb(250 140 22 / var(--tw-text-opacity, 1));
}
.text-flexi-history-placement-bg {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-flexi-history-section {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-flexi-history-section-bg {
  --tw-text-opacity: 1;
  color: rgb(237 233 251 / var(--tw-text-opacity, 1));
}
.text-flexi-history-section-border {
  --tw-text-opacity: 1;
  color: rgb(196 181 248 / var(--tw-text-opacity, 1));
}
.text-flexi-history-widget {
  --tw-text-opacity: 1;
  color: rgb(26 155 140 / var(--tw-text-opacity, 1));
}
.text-flexi-history-widget-bg {
  --tw-text-opacity: 1;
  color: rgb(230 246 244 / var(--tw-text-opacity, 1));
}
.text-flexi-history-widget-border {
  --tw-text-opacity: 1;
  color: rgb(168 222 216 / var(--tw-text-opacity, 1));
}
.text-flexi-logo {
  --tw-text-opacity: 1;
  color: rgb(38 41 89 / var(--tw-text-opacity, 1));
}
.text-flexi-offer-editor {
  --tw-text-opacity: 1;
  color: rgb(39 170 88 / var(--tw-text-opacity, 1));
}
.text-flexi-offer-editor-bg {
  --tw-text-opacity: 1;
  color: rgb(230 243 235 / var(--tw-text-opacity, 1));
}
.text-flexi-placeholder {
  --tw-text-opacity: 1;
  color: rgb(206 202 202 / var(--tw-text-opacity, 1));
}
.text-flexi-primary-color {
  --tw-text-opacity: 1;
  color: rgb(44 180 173 / var(--tw-text-opacity, 1));
}
.text-flexi-qa {
  --tw-text-opacity: 1;
  color: rgb(255 141 116 / var(--tw-text-opacity, 1));
}
.text-flexi-qa-bg {
  --tw-text-opacity: 1;
  color: rgb(255 215 206 / var(--tw-text-opacity, 1));
}
.text-flexi-red {
  --tw-text-opacity: 1;
  color: rgb(243 101 114 / var(--tw-text-opacity, 1));
}
.text-flexi-regular {
  --tw-text-opacity: 1;
  color: rgb(154 160 160 / var(--tw-text-opacity, 1));
}
.text-flexi-regular-bg {
  --tw-text-opacity: 1;
  color: rgb(218 218 218 / var(--tw-text-opacity, 1));
}
.text-flexi-super-admin {
  --tw-text-opacity: 1;
  color: rgb(229 237 253 / var(--tw-text-opacity, 1));
}
.text-flexi-super-admin-bg {
  --tw-text-opacity: 1;
  color: rgb(108 150 241 / var(--tw-text-opacity, 1));
}
.text-flexi-text {
  --tw-text-opacity: 1;
  color: rgb(14 18 20 / var(--tw-text-opacity, 1));
}
.text-flexi-warning {
  --tw-text-opacity: 1;
  color: rgb(240 145 3 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-85 {
  opacity: 0.85;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-\\[1\\.5px\\] {
  outline-width: 1.5px;
}
.outline-offset-\\[0\\.5px\\] {
  outline-offset: 0.5px;
}
.outline-flexi-red {
  outline-color: #F36572;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-flexi-primary-color {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(44 180 173 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.scrollbar-none {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-none::-webkit-scrollbar {
  display: none;
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}
/* Mulish Black */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 900;
  font-style: normal;
}
/* Mulish Black Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 900;
  font-style: italic;
}
/* Mulish Bold */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: 700;
  font-style: normal;
}
/* Mulish Bold Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
  font-weight: 700;
  font-style: italic;
}
/* Mulish SemiBold */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
  font-weight: 600;
  font-style: normal;
}
/* Mulish SemiBold Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
  font-weight: 600;
  font-style: italic;
}
/* Mulish Medium */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}
/* Mulish Medium Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
  font-weight: 500;
  font-style: italic;
}
/* Mulish Regular */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}
/* Mulish Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('truetype');
  font-weight: 400;
  font-style: italic;
}
/* Mulish Light */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('truetype');
  font-weight: 300;
  font-style: normal;
}
/* Mulish Light Italic */
@font-face {
  font-family: Mulish;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format('truetype');
  font-weight: 300;
  font-style: italic;
}
/* raleway-300 - latin */
@font-face {
  font-family: Raleway;
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format('truetype');
}
/* raleway-regular - latin */
@font-face {
  font-family: Raleway;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_40___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format('truetype');
}
/* raleway-500 - latin */
@font-face {
  font-family: Raleway;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format('truetype');
}
/* raleway-600 - latin */
@font-face {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format('truetype');
}
/* raleway-800 - latin */
@font-face {
  font-family: Raleway;
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format('truetype');
}
/* montserrat-300 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format('truetype');
}
/* montserrat-regular - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format('truetype');
}
/* montserrat-500 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format('truetype');
}
/* montserrat-600 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_61___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_62___}) format('truetype');
}
/* montserrat-700 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_63___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_64___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_65___}) format('truetype');
}
/* montserrat-800 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_67___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_68___}) format('truetype');
}
/* montserrat-900 - latin */
@font-face {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_70___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_71___}) format('truetype');
}
@font-face {
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_72___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_73___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_74___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: Lato;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_75___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_76___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_77___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: Poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_78___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_79___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_80___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Open Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_81___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_82___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_83___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: Carlito;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_84___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_85___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_86___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
/* arial light condensed */
@font-face {
  font-family: 'Arial MT Std Light Cond';
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_87___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_88___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_89___}) format('truetype');
}
/* arial light */
@font-face {
  font-family: 'Arial MT Std Light';
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_90___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_91___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_92___}) format('truetype');
}
/* relative bold */
@font-face {
  font-family: 'Relative bold';
  font-style: normal;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_93___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_94___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_95___}) format('truetype');
  font-display: swap;
}
/* relative book */
@font-face {
  font-family: 'Relative Pro Book';
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_96___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_97___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_98___}) format('truetype');
  font-display: swap;
}
/* relative medium */
@font-face {
  font-family: 'Relative Pro Medium';
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_99___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_100___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_101___}) format('truetype');
  font-display: swap;
}
/* relative mono 11 pitch */
@font-face {
  font-family: 'Relative Mono Pro 11 Pitch';
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_102___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_103___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_104___}) format('truetype');
  font-display: swap;
}
/* Cabin */
@font-face {
  font-family: Cabin;
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_105___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_106___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_107___}) format('truetype');
  font-display: swap;
}
/* Cabin Italic */
@font-face {
  font-family: Cabin;
  font-style: italic;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_108___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_109___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_110___}) format('truetype');
  font-display: swap;
}
/* Cabin-700 */
@font-face {
  font-family: Cabin;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_111___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_112___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_113___}) format('truetype');
  font-display: swap;
}
/* Cabin-700 Italic */
@font-face {
  font-family: Cabin;
  font-style: italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_114___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_115___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_116___}) format('truetype');
  font-display: swap;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
body {
  font-family: Mulish, sans-serif;
  background-color: #F1FAFE !important;
  min-height: 100vh;
  margin: 0;
}
input,
textarea,
select {
  outline: none;
}
textarea {
  border: 1px solid var(--flexi-border);
  border-radius: 4px;
}
.badge {
  background: var(--flexi-grey);
  color: #fff;
  padding: 5px 14px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 700;
}
.badge.review {
  background-color: var(--flexi-blue);
}
.badge.release {
  background-color: var(--flexi-valid);
}
.badge.archived {
  background-color: var(--flexi-red);
}
.ant-btn.btn-green {
  background: var(--flexi-valid) !important;
  border-color: var(--flexi-valid) !important;
  color: white !important;
}
.ant-btn.btn-yellow {
  background: var(--flexi-warning) !important;
  border-color: var(--flexi-warning) !important;
  color: white;
  font-size: 15px;
}
table.table-border-light {
  color: var(--flexi-grey);
  border: 1px solid var(--flexi-border);
  border-radius: 4px;
  border-spacing: 0;
  border-collapse: separate;
}
table.table-border-light input {
  font-size: 16px !important;
}
table.table-border-light td:first-child,
table.table-border-light th:first-child {
  border-right: 1px solid var(--flexi-border);
}
table.table-border-light tr:first-child th {
  border-bottom: 1px solid var(--flexi-border);
}
table.table-border-light thead tr:first-child td:first-child {
  border-top-left-radius: 4px;
}
table.table-border-light thead tr:first-child td:last-child {
  border-top-right-radius: 4px;
}
table.table-border-light tbody tr:last-child td:first-child {
  border-bottom-left-radius: 4px;
}
table.table-border-light tbody tr:last-child td:last-child {
  border-bottom-right-radius: 4px;
}
p {
  margin-bottom: 0 !important;
}
[contenteditable] {
  -webkit-user-select: text;
  -moz-user-select: text;
       user-select: text;
}
.info-pdf input[type="checkbox"]:checked {
  position: absolute;
}
[class^="ant-"],
[class*=" ant-"] {
  font-family: Mulish, sans-serif !important;
}
.versions_tree .ant-collapse-content {
  background-color: var(--flexi-col-table) !important;
  border-top: 1px solid var(--flexi-border) !important;
}
.offers-archives-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 0 !important;
}
.offers-archives-collapse .ant-collapse-content-box {
  padding: 0 !important;
}
.versions_tree .ant-collapse-header {
  align-items: baseline !important;
}
.versions_tree .ant-timeline-item {
  padding: 0 !important;
}
.versions_tree .ant-timeline-item-content {
  margin: 0 0 0 20px !important;
}
.versions_tree .ant-collapse-content-box {
  padding: 30px !important;
}
.ant-switch {
  border: none !important;
}
.ant-switch-handle {
  width: 16px !important;
  height: 16px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
.ant-switch-handle::before {
  box-shadow: none !important;
  background-color: #fff !important;
}
.ant-switch-small .ant-switch-handle {
  width: 10px !important;
  height: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
.ant-timeline-item-head {
  padding: 0 !important;
}
.ant-timeline-item-tail {
  border-left: 2px dotted var(--flexi-grey) !important;
}
.timeline_container {
  padding-top: 20px;
}
.timeline_container .ant-timeline-item-label {
  width: 180px !important;
  color: var(--flexi-grey) !important;
  font-size: 14px;
  top: -6.5px !important;
  text-align: left !important;
}
.timeline_container .ant-timeline-item-content {
  left: 180px !important;
  width: calc(80% - 4px) !important;
}
.timeline_container .ant-timeline-item-tail,
.timeline_container .ant-timeline-item-head {
  left: 180px !important;
}
.ant-timeline-item-last > .ant-timeline-item-content {
  min-height: 0 !important;
}
.ant-btn {
  font-weight: 700 !important;
}
.ant-btn-default {
  color: var(--flexi-primary-color);
  border-color: var(--flexi-primary-color);
}
.ant-btn-primary .ant-btn[disabled],
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:active {
  opacity: 0.3 !important;
  color: #fff !important;
  background-color: var(--flexi-primary-color) !important;
  border-color: var(--flexi-primary-color) !important;
}
.ant-btn-default[disabled],
.ant-btn-default[disabled]:hover,
.ant-btn-default[disabled]:focus,
.ant-btn-default[disabled]:active {
  opacity: 0.3 !important;
  color: var(--flexi-primary-color) !important;
  background-color: #fff !important;
  border-color: var(--flexi-primary-color) !important;
}
.btn-undo-redo:hover {
  border-color: var(--flexi-primary-color) !important;
}
.btn-undo-redo,
.btn-undo-redo[disabled],
.btn-undo-redo[disabled]:hover,
.btn-undo-redo[disabled]:focus,
.btn-undo-redo[disabled]:active {
  color: var(--flexi-text) !important;
  border-color: var(--flexi-border) !important;
}
.ant-btn-danger[disabled],
.ant-btn-danger[disabled]:hover,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger[disabled]:active {
  opacity: 0.3 !important;
  color: #fff !important;
  background-color: var(--flexi-red) !important;
  border-color: var(--flexi-red) !important;
}
.ant-btn-loading-icon {
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  background-color: transparent !important;
}
.ant-btn-icon-only {
  justify-content: center !important;
  align-items: center !important;
  display: flex !important;
}
.ant-btn-primary[variant="outlined"] {
  color: var(--flexi-primary-color) !important;
  background-color: white !important;
  border-color: var(--flexi-primary-color) !important;
}
.confirm-filter-btn {
  border-radius: 50px !important;
  padding: 0 10px !important;
}
.ant-table-thead > tr > th {
  font-weight: 700 !important;
  font-size: 13px !important;
  padding: 0 8px !important;
  height: 36px !important;
  background-color: var(--flexi-col-table) !important;
}
.ant-table-measure-row {
  height: 0 !important;
  min-height: 0 !important;
}
.ant-table-measure-row td {
  padding: 0 !important;
  border: none !important;
  height: 0 !important;
}
td.ant-table-column-sort,
.ant-table-tbody > tr.ant-table-row > td {
  background-color: #fff !important;
}
.ant-table-tbody > tr.ant-table-row {
  position: relative;
  transition: box-shadow 0.3s linear;
}
.ant-table-tbody > tr.ant-table-row:hover {
  box-shadow: 0 6px 15px 0 var(--flexi-placeholder);
}
.ant-table-column-sorter-inner .active {
  color: var(--flexi-primary-color) !important;
}
.ant-table-filter-trigger,
.ant-table-column-sorter {
  color: var(--flexi-grey) !important;
}
.ant-table-filter-trigger .active,
.ant-table-column-sorter .active {
  color: var(--flexi-primary-color) !important;
}
.ant-table-filter-dropdown .ant-checkbox-checked::after {
  border: 1px solid var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--flexi-primary-color);
  border-color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-dropdown-menu-item-selected,
.ant-table-filter-dropdown .ant-dropdown-menu-submenu-title-selected {
  color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-btn-link {
  color: var(--flexi-primary-color);
}
.ant-table-filter-dropdown .ant-btn-primary {
  border-color: var(--flexi-primary-color);
  background-color: var(--flexi-primary-color);
}
.ant-pagination-item-active {
  background-color: var(--flexi-primary-color) !important;
  border: none !important;
}
.ant-pagination-item-active a {
  color: #fff !important;
}
.ant-pagination-item {
  border: none !important;
}
.ant-pagination-item:hover {
  color: var(--flexi-primary-color) !important;
}
.ant-pagination-item-link {
  border: none !important;
}
.info-pdf .ant-table-cell a {
  color: var(--flexi-primary-color) !important;
}
.ant-select-dropdown {
  width: 30%;
}
.ant-select-dropdown ul:nth-child(3) {
  flex-grow: 1;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: var(--flexi-select-active) !important;
}
.ant-select-selector {
  border-radius: 2px !important;
}
.ant-select-arrow svg {
  fill: currentcolor;
  color: #000;
}
.ant-select-open .ant-select-selection-item {
  color: #000 !important;
}
.ant-select-item-option-state {
  font-size: 10px !important;
}
.ant-select-item {
  padding: 0 12px !important;
  margin: 0 !important;
  line-height: normal;
  display: flex;
  align-items: center;
}
.ant-alert {
  margin-top: 8px;
  border: none !important;
}
.ant-message-notice-content {
  border-radius: 10px;
  min-width: 240px;
  max-width: 80vw;
  font-size: 14px;
  line-height: 16px;
  padding: 12px 24px;
}
.ant-alert-success,
.ant-notification-notice-success,
.ant-message-notice-success .ant-message-notice-content {
  background-color: var(--flexi-valid-toaster) !important;
  border-radius: 10px !important;
}
.ant-message-notice-info .ant-message-notice-content {
  background-color: var(--flexi-info-toaster) !important;
  border-radius: 10px !important;
}
.ant-message-info .anticon,
.ant-message-loading .anticon {
  color: var(--flexi-primary-color) !important;
}
.ant-alert-error,
.ant-notification-notice-error,
.ant-message-notice-error .ant-message-notice-content {
  background-color: var(--flexi-error-toaster) !important;
  border-radius: 10px !important;
}
.ant-notification-notice-message,
.ant-notification-notice-description,
.ant-message-success .anticon,
.ant-message-error .anticon {
  font-size: 14px !important;
  line-height: 16px !important;
}
.ant-notification-notice-error .ant-notification-notice-message,
.ant-notification-notice-error .ant-notification-notice-description {
  color: var(--flexi-error) !important;
}
.ant-notification-notice .ant-notification-notice-close {
  color: var(--flexi-grey) !important;
  top: 5px !important;
  right: 12px !important;
}
.ant-notification-notice-icon {
  font-size: 18px !important;
  min-width: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}
.ant-notification-notice-closable .ant-notification-notice-message {
  padding-right: 35px !important;
}
.ant-notification-notice-success .ant-notification-notice-message,
.ant-notification-notice-success .ant-notification-notice-description,
.ant-message-success {
  color: var(--flexi-valid) !important;
}
.ant-notification-notice {
  display: inline-block !important;
  width: auto !important;
  max-width: 80vw !important;
  white-space: nowrap !important;
  min-width: 240px !important;
}
.ant-notification-notice-with-icon .ant-notification-notice-message,
.ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-left: 35px !important;
}
.ant-notification-top {
  left: 50% !important;
  transform: translateX(-50%) !important;
  right: auto !important;
  top: 24px !important;
}
.ant-notification-fade-enter,
.ant-notification-fade-appear {
  animation-name: NotificationFadeInDown !important;
}
@keyframes NotificationFadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.ant-cascader {
  width: 80%;
}
.ant-input-number .ant-input-number-handler-wrap,
.ant-input-number-focused .ant-input-number-handler-wrap {
  opacity: 1;
}
.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {
  z-index: 0;
}
.ant-input-number-sm {
  width: 75px;
}
.ant-input-number {
  width: 70px;
  border-radius: 2px !important;
}
.ant-input-prefix {
  color: var(--flexi-placeholder) !important;
}
.ant-input {
  border-radius: 2px !important;
}
.ant-table-filter-dropdown .ant-checkbox-checked,
.ant-collapse .ant-checkbox-checked {
  top: 0;
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-inner,
.ant-collapse .ant-checkbox-checked .ant-checkbox-inner {
  position: absolute !important;
  top: -2px;
}
.ant-table-filter-dropdown .ant-checkbox-checked .ant-checkbox-input,
.ant-collapse .ant-checkbox-checked .ant-checkbox-input {
  margin-right: 14px;
}
.ant-collapse .checkbox-all-outside .ant-checkbox {
  margin-left: 27px;
}
.ant-tree-draggable-icon {
  cursor: grab;
}
.ant-tree-draggable-icon:active {
  cursor: grabbing;
}
.ant-modal-content {
  border-radius: 20px !important;
  padding: 30px 10px !important;
}
.modal-preview-document .ant-modal-content {
  padding: 0 !important;
}
.ant-btn-text span,
.ant-modal-footer .ant-btn-default span,
.ant-popover-buttons .ant-btn-default span {
  text-decoration: underline !important;
}
.ant-modal-header {
  border-bottom: none !important;
  border-radius: 20px 20px 0 0 !important;
}
.ant-modal-footer {
  padding: 0px 24px !important;
  border-top: none !important;
}
.ant-modal-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  line-height: 30px !important;
}
.ant-modal-footer .ant-btn-default,
.ant-popover .ant-btn-cancel {
  background: none !important;
  border: none !important;
  color: var(--flexi-primary-color, #2CB4AD) !important;
  font-weight: 400 !important;
  box-shadow: none !important;
  cursor: pointer;
}
.ant-popover .ant-btn {
  border: none !important;
  box-shadow: none !important;
}
.ant-modal-body {
  padding-top: 0;
}
.ant-modal-body > p {
  font-size: 14px;
  margin-bottom: 30px;
}
.ant-modal-body > b {
  font-size: 13px;
}
.ant-modal-body > .ant-input-affix-wrapper {
  border-radius: 25px !important;
  font-weight: bold;
  font-size: 13px;
  margin: 7px 0;
}
.ant-modal-body > .ant-input-affix-wrapper svg {
  color: var(--flexi-placeholder);
}
.modal-buttons {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}
.modal-buttons .ant-btn-text {
  color: var(--flexi-primary-color);
}
.ant-popover-message > .anticon {
  color: var(--flexi-warning) !important;
}
.ant-table-tbody .ant-table-cell .anticon {
  transition: all 0.3s linear;
  border-radius: 4px;
}
.ant-table-tbody .ant-table-cell .anticon:hover {
  background-color: var(--flexi-col-table) !important;
}
.ant-tag-custom .ant-tag {
  margin: 0 !important;
  padding: 0 !important;
}
.flexi-rich-tooltip .ant-tooltip-inner {
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: Roboto, sans-serif;
  white-space: normal;
  max-width: 450px;
  min-width: 0;
}
.flexi-rich-tooltip .ant-tooltip-arrow {
  display: none;
}
.flexi-rich-tooltip ul {
  margin: 4px 0 0;
  padding-left: 16px;
  list-style: disc;
}
.flexi-rich-tooltip ul li {
  margin: 0;
  padding: 0;
}
.hover\\:border-flexi-primary-color:hover {
  --tw-border-opacity: 1;
  border-color: rgb(44 180 173 / var(--tw-border-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:\\!text-flexi-primary-color:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(44 180 173 / var(--tw-text-opacity, 1)) !important;
}
.hover\\:text-flexi-grey:hover {
  --tw-text-opacity: 1;
  color: rgb(135 143 143 / var(--tw-text-opacity, 1));
}
.hover\\:text-flexi-primary-color:hover {
  --tw-text-opacity: 1;
  color: rgb(44 180 173 / var(--tw-text-opacity, 1));
}
.hover\\:text-flexi-red:hover {
  --tw-text-opacity: 1;
  color: rgb(243 101 114 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}
.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity, 1));
}
@media (min-width: 0px) {

  .xs\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (min-width: 640px) {

  .sm\\:inset-y-0 {
    top: 0px;
    bottom: 0px;
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:pr-\\[2\\.5rem\\] {
    padding-right: 2.5rem;
  }

  .sm\\:shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 768px) {

  .md\\:visible {
    visibility: visible;
  }

  .md\\:static {
    position: static;
  }

  .md\\:ml-10 {
    margin-left: 2.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:min-w-0 {
    min-width: 0px;
  }

  .md\\:flex-1 {
    flex: 1 1 0%;
  }

  .md\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }
}
.\\[\\&\\&\\]\\:\\!font-normal.\\[\\&\\&\\]\\:\\!font-normal {
  font-weight: 400 !important;
}
`, "",{"version":3,"sources":["webpack://./app/less/app.less","webpack://./app/less/fonts.less","webpack://./app/less/antd-custom.less"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA,uBAAA;EAAA,0BAAA;EAAA,aAAA;EAAA,aAAA;EAAA,8BAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,0BAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,qBAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,sBAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,sBAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,sCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA;AAAA;EAAA;IAAA,qBAAA;EAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;KAAA,qBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;OAAA;AAAA;AAAA;EAAA,uBAAA;OAAA;AAAA;AAAA;EAAA,wBAAA;OAAA;AAAA;AAAA;EAAA,qBAAA;OAAA;AAAA;AAAA;EAAA,uBAAA;OAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;KAAA;AAAA;AAAA;EAAA,oBAAA;KAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AACA,iBAAiB;ACFjB;EACI,mBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ADEJ;AACA,wBAAwB;ACCxB;EACI,mBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ADDJ;AACA,gBAAgB;ACIhB;EACI,mBAAA;EACA,gLAAA;EAGA,gBAAA;EACA,kBAAA;ADJJ;AACA,uBAAuB;ACOvB;EACI,mBAAA;EACA,kLAAA;EAGA,gBAAA;EACA,kBAAA;ADPJ;AACA,oBAAoB;ACUpB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADVJ;AACA,2BAA2B;ACa3B;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADbJ;AACA,kBAAkB;ACgBlB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADhBJ;AACA,yBAAyB;ACmBzB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADnBJ;AACA,mBAAmB;ACsBnB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADtBJ;AACA,kBAAkB;ACyBlB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;ADzBJ;AACA,iBAAiB;AC4BjB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;AD5BJ;AACA,wBAAwB;AC+BxB;EACI,mBAAA;EACA,mLAAA;EAGA,gBAAA;EACA,kBAAA;AD/BJ;AACA,wBAAwB;ACkCxB;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADhCF;AACA,4BAA4B;ACqC5B;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADnCF;AACA,wBAAwB;ACwCxB;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADtCF;AACA,wBAAwB;AC2CxB;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADzCF;AACA,wBAAwB;AC8CxB;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;AD5CF;AACA,2BAA2B;ACiD3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;AD/CF;AACA,+BAA+B;ACoD/B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADlDF;AACA,2BAA2B;ACuD3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADrDF;AACA,2BAA2B;AC0D3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADxDF;AACA,2BAA2B;AC6D3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;AD3DF;AACA,2BAA2B;ACgE3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;AD9DF;AACA,2BAA2B;ACmE3B;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADjEF;ACsEA;EACE,mBAAA;EACA,mLAAA;EAGA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADtEF;ACyEA;EACE,iBAAA;EACA,mLAAA;EAGA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADzEF;AC4EA;EACE,oBAAA;EACA,mLAAA;EAGA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD5EF;AC+EA;EACE,wBAAA;EACA,mLAAA;EAGA,mBAAA;EACA,kBAAA;EACA,kBAAA;AD/EF;ACkFA;EACE,oBAAA;EACA,mLAAA;EAGA,mBAAA;EACA,kBAAA;EACA,kBAAA;ADlFF;AACA,0BAA0B;ACqF1B;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADnFF;AACA,gBAAgB;ACyFhB;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mLAAA;ADvFF;AACA,kBAAkB;AC4FlB;EACE,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mLAAA;EAGA,kBAAA;AD5FF;AACA,kBAAkB;AC+FlB;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mLAAA;EAGA,kBAAA;AD/FF;AACA,oBAAoB;ACkGpB;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qLAAA;EAGA,kBAAA;ADlGF;AACA,2BAA2B;ACqG3B;EACE,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,sLAAA;EAGA,kBAAA;ADrGF;AACA,UAAU;ACwGV;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sLAAA;EAGA,kBAAA;ADxGF;AACA,iBAAiB;AC2GjB;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sLAAA;EAGA,kBAAA;AD3GF;AACA,cAAc;AC8Gd;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sLAAA;EAGA,kBAAA;AD9GF;AACA,qBAAqB;ACiHrB;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sLAAA;EAGA,kBAAA;ADjHF;AA/QA;;;EAKE,sBAAA;AAsRF;AAnRA;EACE,+BAAA;EACA,oCAAA;EACA,iBAAA;EACA,SAAA;AAqRF;AAlRA;;;EAGE,aAAA;AAoRF;AAjRA;EACE,qCAAA;EACA,kBAAA;AAmRF;AAhRA;EACE,6BAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAkRF;AAhRE;EACE,mCAAA;AAkRJ;AA/QE;EACE,oCAAA;AAiRJ;AA9QE;EACE,kCAAA;AAgRJ;AA5QA;EACE,yCAAA;EACA,2CAAA;EACA,uBAAA;AA8QF;AA3QA;EACE,2CAAA;EACA,6CAAA;EACA,YAAA;EACA,eAAA;AA6QF;AA1QA;EACE,wBAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AA4QF;AAjRA;EAQI,0BAAA;AA4QJ;AApRA;;EAaI,2CAAA;AA2QJ;AAxRA;EAiBI,4CAAA;AA0QJ;AA3RA;EAqBI,2BAAA;AAyQJ;AA9RA;EAyBI,4BAAA;AAwQJ;AAjSA;EA6BI,8BAAA;AAuQJ;AApSA;EAiCI,+BAAA;AAsQJ;AAlQA;EACE,2BAAA;AAoQF;AAjQA;EACE,yBAAA;EACA,sBAAA;OAAA,iBAAA;AAmQF;AA9PE;EAAA;AAAA;AE3HF;;EACE,0CAAA;AF+XF;AE1WA;EACE,mDAAA;EACA,oDAAA;AF4WF;AEzWA;EAEI,qBAAA;AF0WJ;AE5WA;EAKI,qBAAA;AF0WJ;AEtWA;EAEI,gCAAA;AFuWJ;AEzWA;EAMI,qBAAA;AFsWJ;AE5WA;EAUI,6BAAA;AFqWJ;AE/WA;EAcI,wBAAA;AFoWJ;AE/VA;EACE,uBAAA;AFiWF;AE9VA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;AFgWF;AE9VE;EACE,2BAAA;EACA,iCAAA;AFgWJ;AE5VA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;AF8VF;AE1VA;EACE,qBAAA;AF4VF;AEzVA;EACE,oDAAA;AF2VF;AExVA;EACE,iBAAA;AF0VF;AE3VA;EAII,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;AF0VJ;AElWA;EAYI,sBAAA;EACA,iCAAA;AFyVJ;AEtWA;;EAkBI,sBAAA;AFwVJ;AEpVA;EACE,wBAAA;AFsVF;AElVA;EACE,2BAAA;AFoVF;AEjVA;EACE,iCAAA;EACA,wCAAA;AFmVF;AEhVA;;;;;;EACE,uBAAA;EACA,sBAAA;EACA,uDAAA;EACA,mDAAA;AFuVF;AEpVA;;;;EACE,uBAAA;EACA,4CAAA;EACA,iCAAA;EACA,mDAAA;AFyVF;AEtVA;EACE,mDAAA;AFwVF;AErVA;;;;;EACE,mCAAA;EACA,4CAAA;AF2VF;AExVA;;;;EACE,uBAAA;EACA,sBAAA;EACA,6CAAA;EACA,yCAAA;AF6VF;AE1VA;EACE,uEAAA;AF4VF;AEzVA;;EACE,wCAAA;AF4VF;AEzVA;EACE,kCAAA;EACA,8BAAA;EACA,wBAAA;AF2VF;AExVA;EACE,4CAAA;EACA,kCAAA;EACA,mDAAA;AF0VF;AEvVA;EACE,8BAAA;EACA,0BAAA;AFyVF;AEtVA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,mDAAA;AFwVF;AErVA;EACE,oBAAA;EACA,wBAAA;AFuVF;AEzVA;EAKI,qBAAA;EACA,uBAAA;EACA,oBAAA;AFuVJ;AEnVA;;EACE,iCAAA;AFsVF;AEnVA;EACE,kBAAA;EACA,kCAAA;AFqVF;AEnVE;EACE,iDAAA;AFqVJ;AEjVA;EACE,4CAAA;AFmVF;AEhVA;;EACE,mCAAA;AFmVF;AEpVA;;EAII,4CAAA;AFoVJ;AE9UI;EACE,4CAAA;AFgVN;AEnVA;EAOM,4CAAA;EACA,wCAAA;AF+UN;AEvVA;;EAaI,iCAAA;AF8UJ;AE3VA;EAiBI,iCAAA;AF6UJ;AE9VA;EAqBI,wCAAA;EACA,4CAAA;AF4UJ;AExUA;EACE,uDAAA;EACA,uBAAA;AF0UF;AE5UA;EAKI,sBAAA;AF0UJ;AEtUA;EACE,uBAAA;AFwUF;AEtUE;EACE,4CAAA;AFwUJ;AEpUA;EACE,uBAAA;AFsUF;AEnUA;EACE,4CAAA;AFqUF;AE9TA;EACE,UAAA;AFgUF;AEjUA;EAII,YAAA;AFgUJ;AE5TA;EACE,uDAAA;AF8TF;AE3TA;EACE,6BAAA;AF6TF;AE1TA;EACC,kBAAA;EACA,WAAA;AF4TD;AEzTA;EACE,sBAAA;AF2TF;AExTA;EACE,0BAAA;AF0TF;AEvTA;EACE,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AFyTF;AErTA;EACE,eAAA;EACA,uBAAA;AFuTF;AEpTA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AFsTF;AEnTA;;;EACE,uDAAA;EACA,8BAAA;AFuTF;AEpTA;EACE,sDAAA;EACA,8BAAA;AFsTF;AEnTA;;EACE,4CAAA;AFsTF;AEnTA;;;EACE,uDAAA;EACA,8BAAA;AFuTF;AEpTA;;;;EAGE,0BAAA;EACA,4BAAA;AFuTF;AEpTA;;EAEE,oCAAA;AFsTF;AEnTA;EACE,mCAAA;EACA,mBAAA;EACA,sBAAA;AFqTF;AElTA;EACE,0BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AFoTF;AEjTA;EACE,8BAAA;AFmTF;AEhTA;;;EAEE,oCAAA;AFmTF;AEhTA;EACE,gCAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AFkTF;AE/SA;;EACE,4BAAA;AFkTF;AE/SA;EACE,oBAAA;EACA,sCAAA;EACA,sBAAA;EACA,oBAAA;AFiTF;AE9SA;;EACE,iDAAA;AFiTF;AE9SA;EACE;IACE,UAAA;IACA,4BAAA;EFgTF;EE7SA;IACE,UAAA;IACA,wBAAA;EF+SF;AACF;AE5SA;EACE,UAAA;AF8SF;AEzSA;;EACE,UAAA;AF4SF;AEzSA;EACE,UAAA;AF2SF;AExSA;EACE,WAAA;AF0SF;AEvSA;EACE,WAAA;EACA,6BAAA;AFySF;AEtSA;EACE,0CAAA;AFwSF;AErSA;EACE,6BAAA;AFuSF;AEpSA;;EACE,MAAA;AFuSF;AExSA;;EAII,6BAAA;EACA,SAAA;AFwSJ;AE7SA;;EASI,kBAAA;AFwSJ;AEpSA;EACC,iBAAA;AFsSD;AEnSA;EACE,YAAA;AFqSF;AEnSI;EACA,gBAAA;AFqSJ;AEhSA;EACE,8BAAA;EACA,6BAAA;AFkSF;AE/RA;EACE,qBAAA;AFiSF;AE9RA;;;EACE,qCAAA;AFkSF;AE/RA;EACE,8BAAA;EACA,uCAAA;AFiSF;AE9RA;EACE,4BAAA;EACA,2BAAA;AFgSF;AE7RA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;AF+RF;AE5RA;;EACE,2BAAA;EACA,uBAAA;EACA,qDAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;AF+RF;AE5RA;EACE,uBAAA;EACA,2BAAA;AF8RF;AE3RA;EACI,cAAA;AF6RJ;AE9RA;EAIM,eAAA;EACA,mBAAA;AF6RN;AElSA;EASM,eAAA;AF4RN;AErSA;EAaM,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AF2RN;AE3SA;EAmBQ,+BAAA;AF2RR;AErRA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AFuRF;AE1RA;EAMI,iCAAA;AFuRJ;AEnRA;EACE,sCAAA;AFqRF;AElRA;EACE,2BAAA;EACA,kBAAA;AFoRF;AElRE;EACE,mDAAA;AFoRJ;AEhRA;EACE,oBAAA;EACA,qBAAA;AFkRF;AE9QA;EAEI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,yCAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AF+QJ;AE1RA;EAeI,aAAA;AF8QJ;AE7RA;EAmBI,eAAA;EACA,kBAAA;EACA,gBAAA;AF6QJ;AElSA;EAwBM,SAAA;EACA,UAAA;AF6QN;AAl2BA;EAAA,sBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,kBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,kBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,+BAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA;AAm2BA;AAn2BA;EAAA,8BAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,2GAm2BA;EAn2BA,yGAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;EAAA,oBAm2BA;EAn2BA;AAm2BA;AAn2BA;;EAAA;IAAA;EAm2BA;AAAA;AAn2BA;;EAAA;IAAA,QAm2BA;IAn2BA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA,+EAm2BA;IAn2BA,mGAm2BA;IAn2BA;EAm2BA;AAAA;AAn2BA;;EAAA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA;EAm2BA;;EAn2BA;IAAA,uBAm2BA;IAn2BA,oDAm2BA;IAn2BA;EAm2BA;AAAA;AAn2BA;EAAA;AAm2BA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import './fonts.less';\n\n@layer base {\n  svg {\n    vertical-align: unset;\n  }\n}\n\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: Mulish, sans-serif;\n  background-color: #F1FAFE !important;\n  min-height: 100vh;\n  margin: 0;\n}\n\ninput,\ntextarea,\nselect {\n  outline: none;\n}\n\ntextarea {\n  border: 1px solid var(--flexi-border);\n  border-radius: 4px;\n}\n\n.badge {\n  background: var(--flexi-grey);\n  color: #fff;\n  padding: 5px 14px;\n  text-align: center;\n  display: inline-block;\n  vertical-align: middle;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 700;\n\n  &.review {\n    background-color: var(--flexi-blue);\n  }\n\n  &.release {\n    background-color: var(--flexi-valid);\n  }\n\n  &.archived {\n    background-color: var(--flexi-red);\n  }\n}\n\n.ant-btn.btn-green {\n  background: var(--flexi-valid) !important;\n  border-color: var(--flexi-valid) !important;\n  color: white !important;\n}\n\n.ant-btn.btn-yellow {\n  background: var(--flexi-warning) !important;\n  border-color: var(--flexi-warning) !important;\n  color: white;\n  font-size: 15px;\n}\n\ntable.table-border-light {\n  color: var(--flexi-grey);\n  border: 1px solid var(--flexi-border);\n  border-radius: 4px;\n  border-spacing: 0;\n  border-collapse: separate;\n\n  input {\n    font-size: 16px !important;\n  }\n\n  td:first-child,\n  th:first-child {\n    border-right: 1px solid var(--flexi-border);\n  }\n\n  tr:first-child th {\n    border-bottom: 1px solid var(--flexi-border);\n  }\n\n  thead tr:first-child td:first-child {\n    border-top-left-radius: 4px;\n  }\n\n  thead tr:first-child td:last-child {\n    border-top-right-radius: 4px;\n  }\n\n  tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 4px;\n  }\n\n  tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 4px;\n  }\n}\n\np {\n  margin-bottom: 0 !important;\n}\n\n[contenteditable] {\n  -webkit-user-select: text;\n  user-select: text;\n}\n\n\n.info-pdf input[type=\"checkbox\"]:checked {\n  @apply absolute;\n}\n\n@hack: true; @import \"/service/app/less/antd-custom.less\";","/* Mulish Black */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Black.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Black.woff') format('woff'),\n       url('../assets/fonts/Mulish-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n}\n\n/* Mulish Black Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-BlackItalic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-BlackItalic.woff') format('woff'),\n       url('../assets/fonts/Mulish-BlackItalic.ttf') format('truetype');\n    font-weight: 900;\n    font-style: italic;\n}\n\n/* Mulish Bold */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Bold.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Bold.woff') format('woff'),\n       url('../assets/fonts/Mulish-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n}\n\n/* Mulish Bold Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-BoldItalic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-BoldItalic.woff') format('woff'),\n       url('../assets/fonts/Mulish-BoldItalic.ttf') format('truetype');\n    font-weight: 700;\n    font-style: italic;\n}\n\n/* Mulish SemiBold */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-SemiBold.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-SemiBold.woff') format('woff'),\n       url('../assets/fonts/Mulish-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n}\n\n/* Mulish SemiBold Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-SemiBoldItalic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-SemiBoldItalic.woff') format('woff'),\n       url('../assets/fonts/Mulish-SemiBoldItalic.ttf') format('truetype');\n    font-weight: 600;\n    font-style: italic;\n}\n\n/* Mulish Medium */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Medium.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Medium.woff') format('woff'),\n       url('../assets/fonts/Mulish-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n/* Mulish Medium Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-MediumItalic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-MediumItalic.woff') format('woff'),\n       url('../assets/fonts/Mulish-MediumItalic.ttf') format('truetype');\n    font-weight: 500;\n    font-style: italic;\n}\n\n/* Mulish Regular */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Regular.woff') format('woff'),\n       url('../assets/fonts/Mulish-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n}\n\n/* Mulish Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Italic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Italic.woff') format('woff'),\n       url('../assets/fonts/Mulish-Italic.ttf') format('truetype');\n    font-weight: 400;\n    font-style: italic;\n}\n\n/* Mulish Light */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-Light.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-Light.woff') format('woff'),\n       url('../assets/fonts/Mulish-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n}\n\n/* Mulish Light Italic */\n@font-face {\n    font-family: Mulish;\n    src: url('../assets/fonts/Mulish-LightItalic.woff2') format('woff2'),\n       url('../assets/fonts/Mulish-LightItalic.woff') format('woff'),\n       url('../assets/fonts/Mulish-LightItalic.ttf') format('truetype');\n    font-weight: 300;\n    font-style: italic;\n}\n\n/* raleway-300 - latin */\n@font-face {\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/fonts/raleway-v13-latin-300.woff2') format('woff2'),\n       url('../assets/fonts/raleway-v13-latin-300.woff') format('woff'),\n       url('../assets/fonts/raleway-v13-latin-300.ttf') format('truetype');\n}\n\n/* raleway-regular - latin */\n@font-face {\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/fonts/raleway-v13-latin-regular.woff2') format('woff2'),\n       url('../assets/fonts/raleway-v13-latin-regular.woff') format('woff'),\n       url('../assets/fonts/raleway-v13-latin-regular.ttf') format('truetype');\n}\n\n/* raleway-500 - latin */\n@font-face {\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/fonts/raleway-v13-latin-500.woff2') format('woff2'),\n       url('../assets/fonts/raleway-v13-latin-500.woff') format('woff'),\n       url('../assets/fonts/raleway-v13-latin-500.ttf') format('truetype');\n}\n\n/* raleway-600 - latin */\n@font-face {\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/fonts/raleway-v13-latin-600.woff2') format('woff2'),\n       url('../assets/fonts/raleway-v13-latin-600.woff') format('woff'),\n       url('../assets/fonts/raleway-v13-latin-600.ttf') format('truetype');\n}\n\n/* raleway-800 - latin */\n@font-face {\n  font-family: Raleway;\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/fonts/raleway-v13-latin-800.woff2') format('woff2'),\n      url('../assets/fonts/raleway-v13-latin-800.woff') format('woff'),\n       url('../assets/fonts/raleway-v13-latin-800.ttf') format('truetype');\n}\n\n/* montserrat-300 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/fonts/montserrat-v14-latin-300.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v14-latin-300.woff') format('woff'),\n       url('../assets/fonts/montserrat-v14-latin-300.ttf') format('truetype');\n}\n\n/* montserrat-regular - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/fonts/montserrat-v18-latin-regular.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-regular.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-regular.ttf') format('truetype');\n}\n\n/* montserrat-500 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/fonts/montserrat-v18-latin-500.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-500.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-500.ttf') format('truetype');\n}\n\n/* montserrat-600 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/fonts/montserrat-v18-latin-600.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-600.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-600.ttf') format('truetype');\n}\n\n/* montserrat-700 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/fonts/montserrat-v18-latin-700.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-700.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-700.ttf') format('truetype');\n}\n\n/* montserrat-800 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/fonts/montserrat-v18-latin-800.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-800.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-800.ttf') format('truetype');\n}\n\n/* montserrat-900 - latin */\n@font-face {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/fonts/montserrat-v18-latin-900.woff2') format('woff2'),\n       url('../assets/fonts/montserrat-v18-latin-900.woff') format('woff'),\n       url('../assets/fonts/montserrat-v18-latin-900.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: Roboto;\n  src: url('../assets/fonts/Roboto-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Roboto-Regular.woff') format('woff'),\n       url('../assets/fonts/Roboto-Regular.ttf') format('truetype'); \n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Lato;\n  src: url('../assets/fonts/Lato-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Lato-Regular.woff') format('woff'),\n       url('../assets/fonts/Lato-Regular.ttf') format('truetype'); \n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Poppins;\n  src: url('../assets/fonts/Poppins-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Poppins-Regular.woff') format('woff'),\n       url('../assets/fonts/Poppins-Regular.ttf') format('truetype'); \n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  src: url('../assets/fonts/OpenSans-Regular.woff2') format('woff2'),\n       url('../assets/fonts/OpenSans-Regular.woff') format('woff'),\n       url('../assets/fonts/OpenSans-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Carlito;\n  src: url('../assets/fonts/Carlito-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Carlito-Regular.woff') format('woff'),\n       url('../assets/fonts/Carlito-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* arial light condensed */\n@font-face {\n  font-family: 'Arial MT Std Light Cond';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/fonts/ArialMTStd-LightCond.woff2') format('woff2'),\n       url('../assets/fonts/ArialMTStd-LightCond.woff') format('woff'),\n       url('../assets/fonts/ArialMTStd-LightCond.ttf') format('truetype');\n}\n\n\n/* arial light */\n@font-face {\n  font-family: 'Arial MT Std Light';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/fonts/ArialMTStd-Light.woff2') format('woff2'),\n       url('../assets/fonts/ArialMTStd-Light.woff') format('woff'),\n       url('../assets/fonts/ArialMTStd-Light.ttf') format('truetype');\n}\n\n/* relative bold */\n@font-face {\n  font-family: 'Relative bold';\n  font-style: normal;\n  font-weight: bold;\n  src: url('../assets/fonts/relative-bold-pro.woff2') format('woff2'),\n       url('../assets/fonts/relative-bold-pro.woff') format('woff'),\n       url('../assets/fonts/relative-bold-pro.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* relative book */\n@font-face {\n  font-family: 'Relative Pro Book';\n  font-style: normal;\n  font-weight: normal;\n  src: url('../assets/fonts/relative-book-pro.woff2') format('woff2'),\n       url('../assets/fonts/relative-book-pro.woff') format('woff'),\n       url('../assets/fonts/relative-book-pro.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* relative medium */\n@font-face {\n  font-family: 'Relative Pro Medium';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/fonts/relative-medium-pro.woff2') format('woff2'),\n       url('../assets/fonts/relative-medium-pro.woff') format('woff'),\n       url('../assets/fonts/relative-medium-pro.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* relative mono 11 pitch */\n@font-face {\n  font-family: 'Relative Mono Pro 11 Pitch';\n  font-style: normal;\n  font-weight: normal;\n  src: url('../assets/fonts/relative-mono-11-pitch-pro.woff2') format('woff2'),\n       url('../assets/fonts/relative-mono-11-pitch-pro.woff') format('woff'),\n       url('../assets/fonts/relative-mono-11-pitch-pro.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* Cabin */\n@font-face {\n  font-family: Cabin;\n  font-style: normal;\n  font-weight: normal;\n  src: url('../assets/fonts/Cabin-Regular.woff2') format('woff2'),\n       url('../assets/fonts/Cabin-Regular.woff') format('woff'),\n       url('../assets/fonts/Cabin-Regular.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* Cabin Italic */\n@font-face {\n  font-family: Cabin;\n  font-style: italic;\n  font-weight: normal;\n  src: url('../assets/fonts/Cabin-Italic.woff2') format('woff2'),\n       url('../assets/fonts/Cabin-Italic.woff') format('woff'),\n       url('../assets/fonts/Cabin-Italic.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* Cabin-700 */\n@font-face {\n  font-family: Cabin;\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/fonts/Cabin-Bold.woff2') format('woff2'),\n       url('../assets/fonts/Cabin-Bold.woff') format('woff'),\n       url('../assets/fonts/Cabin-Bold.ttf') format('truetype');\n  font-display: swap;\n}\n\n/* Cabin-700 Italic */\n@font-face {\n  font-family: Cabin;\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/fonts/Cabin-BoldItalic.woff2') format('woff2'),\n       url('../assets/fonts/Cabin-BoldItalic.woff') format('woff'),\n       url('../assets/fonts/Cabin-BoldItalic.ttf') format('truetype');\n  font-display: swap;\n}","[class^=\"ant-\"], [class*=\" ant-\"] {\n  font-family: Mulish, sans-serif !important;\n}\n@input-font-size: 13px;\n@input-font-size-lg: 14px;\n@border-radius-base: 4px;\n\n@btn-padding-horizontal-lg: 30px;\n@btn-padding-horizontal-base: 20px;\n@btn-border-radius-base: 30px;\n\n@select-single-item-height-lg: 50px;\n\n@primary-color: #2CB4AD;\n\n@slider-handle-border-width: 8px;\n\n@btn-default-border: #E5E7EB;\n@btn-default-color: #2CB4AD;;\n@btn-font-size-lg: 14px;\n\n// ANT COLLAPSE\n.versions_tree .ant-collapse-content {\n  background-color: var(--flexi-col-table) !important;\n  border-top: 1px solid var(--flexi-border) !important;\n}\n\n.offers-archives-collapse {\n  > .ant-collapse-item > .ant-collapse-header {\n    padding: 0 !important;\n  }\n  .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n}\n\n.versions_tree {\n  .ant-collapse-header {\n    align-items: baseline !important;\n  }\n\n  .ant-timeline-item {\n    padding: 0 !important;\n  }\n\n  .ant-timeline-item-content {\n    margin: 0 0 0 20px !important;\n  }\n  \n  .ant-collapse-content-box {\n    padding: 30px !important;\n  }\n}\n\n// ANT SWITCH\n.ant-switch {\n  border:none !important;\n}\n\n.ant-switch-handle {\n  width: 16px !important;\n  height: 16px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n\n  &::before {\n    box-shadow: none !important;\n    background-color: #fff !important;\n  }\n}\n\n.ant-switch-small .ant-switch-handle {\n  width: 10px !important;\n  height: 10px !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n}\n\n// ANT TIMELINE\n.ant-timeline-item-head {\n  padding: 0 !important;\n}\n\n.ant-timeline-item-tail {\n  border-left: 2px dotted var(--flexi-grey) !important;\n}\n\n.timeline_container {\n  padding-top: 20px;\n\n  .ant-timeline-item-label {\n    width: 180px !important;\n    color: var(--flexi-grey) !important;\n    font-size: 14px;\n    top: -6.5px !important;\n    text-align: left !important;\n  }\n\n  .ant-timeline-item-content {\n    left: 180px !important;\n    width: calc(80% - 4px) !important;\n  }\n\n  .ant-timeline-item-tail,\n  .ant-timeline-item-head {\n    left: 180px !important;\n  }\n}\n\n.ant-timeline-item-last > .ant-timeline-item-content {\n  min-height: 0 !important;\n}\n\n// ANT BUTTON\n.ant-btn {\n  font-weight: 700 !important;\n}\n\n.ant-btn-default {\n  color: var(--flexi-primary-color);\n  border-color: var(--flexi-primary-color)\n}\n\n.ant-btn-primary .ant-btn[disabled], .ant-btn-primary[disabled], .ant-btn-primary[disabled]:hover, .ant-btn-primary[disabled]:focus, .ant-btn-primary[disabled]:active.ant-btn-primary[disabled], .ant-btn-primary[disabled]:active {\n  opacity: 0.3 !important;\n  color: #fff !important;\n  background-color: var(--flexi-primary-color) !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.ant-btn-default[disabled], .ant-btn-default[disabled]:hover, .ant-btn-default[disabled]:focus, .ant-btn-default[disabled]:active {\n  opacity: 0.3 !important;\n  color: var(--flexi-primary-color) !important;\n  background-color: #fff !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.btn-undo-redo:hover {\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.btn-undo-redo, .btn-undo-redo[disabled], .btn-undo-redo[disabled]:hover, .btn-undo-redo[disabled]:focus, .btn-undo-redo[disabled]:active{\n  color: var(--flexi-text) !important;\n  border-color: var(--flexi-border) !important;\n}\n\n.ant-btn-danger[disabled], .ant-btn-danger[disabled]:hover, .ant-btn-danger[disabled]:focus, .ant-btn-danger[disabled]:active {\n  opacity: 0.3 !important;\n  color: #fff !important;\n  background-color: var(--flexi-red) !important;\n  border-color: var(--flexi-red) !important;\n}\n\n.ant-btn-loading-icon {\n  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out !important; // fix firefox displayed loading icon\n}\n\n.ant-btn-text:hover, .ant-btn-text:focus {\n  background-color: transparent !important;\n}\n\n.ant-btn-icon-only {\n  justify-content: center !important;\n  align-items: center !important;\n  display: flex !important;\n}\n\n.ant-btn-primary[variant=\"outlined\"] {\n  color: var(--flexi-primary-color) !important;\n  background-color: white !important;\n  border-color: var(--flexi-primary-color) !important;\n}\n\n.confirm-filter-btn {\n  border-radius: 50px !important;\n  padding: 0 10px !important;\n}\n// ANT TABLE\n.ant-table-thead > tr > th {\n  font-weight: 700 !important;\n  font-size: 13px !important;\n  padding: 0 8px !important;\n  height: 36px !important;\n  background-color: var(--flexi-col-table) !important;\n}\n\n.ant-table-measure-row {\n  height: 0 !important;\n  min-height: 0 !important;\n\n  td {\n    padding: 0 !important;\n    border: none !important;\n    height: 0 !important;\n  }\n}\n\ntd.ant-table-column-sort, .ant-table-tbody > tr.ant-table-row > td {\n  background-color: #fff !important;\n}\n\n.ant-table-tbody > tr.ant-table-row {\n  position: relative;\n  transition: box-shadow .3s linear;\n\n  &:hover {\n    box-shadow: 0 6px 15px 0 var(--flexi-placeholder);\n  }\n}\n\n.ant-table-column-sorter-inner .active {\n  color: var(--flexi-primary-color) !important;\n}\n\n.ant-table-filter-trigger, .ant-table-column-sorter {\n  color: var(--flexi-grey) !important;\n\n  .active {\n    color: var(--flexi-primary-color) !important;\n  }\n}\n\n.ant-table-filter-dropdown {\n  .ant-checkbox-checked {\n    &::after {\n      border: 1px solid var(--flexi-primary-color);\n    }\n\n    .ant-checkbox-inner {\n      background-color: var(--flexi-primary-color);\n      border-color: var(--flexi-primary-color);\n    }\n  }\n\n  .ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected {\n    color: var(--flexi-primary-color);\n  }\n\n  .ant-btn-link {\n    color: var(--flexi-primary-color);\n  }\n\n  .ant-btn-primary {\n    border-color: var(--flexi-primary-color);\n    background-color: var(--flexi-primary-color);\n  }\n}\n\n.ant-pagination-item-active {\n  background-color: var(--flexi-primary-color) !important;\n  border: none !important;\n\n  a {\n    color: #fff !important;\n  }\n}\n\n.ant-pagination-item {\n  border: none !important;\n\n  &:hover {\n    color: var(--flexi-primary-color) !important;\n  }\n}\n\n.ant-pagination-item-link {\n  border: none !important;\n}\n\n.info-pdf .ant-table-cell a {\n  color: var(--flexi-primary-color) !important;\n}\n\n// ANT SELECT\n@select-selection-item-bg: var(--flexi-select-active);\n@select-selection-item-border-color: var(--flexi-border);\n\n.ant-select-dropdown{\n  width: 30%;\n\n  ul:nth-child(3){\n    flex-grow: 1;\n  }\n}\n\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  background-color: var(--flexi-select-active) !important;\n}\n\n.ant-select-selector{\n  border-radius: 2px !important;\n}\n\n.ant-select-arrow svg{\n fill: currentcolor;\n color: #000;\n}\n\n.ant-select-open .ant-select-selection-item{\n  color: #000 !important;\n}\n\n.ant-select-item-option-state {\n  font-size: 10px !important;\n}\n\n.ant-select-item {\n  padding: 0 12px !important;\n  margin: 0 !important;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n}\n\n// NOTIFICATION & ALERT\n.ant-alert {\n  margin-top: 8px;\n  border:none !important;\n}\n\n.ant-message-notice-content {\n  border-radius: 10px;\n  min-width: 240px;\n  max-width: 80vw;\n  font-size: 14px;\n  line-height: 16px;\n  padding: 12px 24px;\n}\n\n.ant-alert-success, .ant-notification-notice-success, .ant-message-notice-success .ant-message-notice-content  {\n  background-color: var(--flexi-valid-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-message-notice-info .ant-message-notice-content  {\n  background-color: var(--flexi-info-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-message-info .anticon, .ant-message-loading .anticon {\n  color: var(--flexi-primary-color) !important;\n}\n\n.ant-alert-error, .ant-notification-notice-error, .ant-message-notice-error .ant-message-notice-content {\n  background-color: var(--flexi-error-toaster) !important;\n  border-radius: 10px !important;\n}\n\n.ant-notification-notice-message,\n.ant-notification-notice-description, .ant-message-success .anticon,\n.ant-message-error .anticon {\n  font-size: 14px !important;\n  line-height: 16px !important;\n}\n\n.ant-notification-notice-error .ant-notification-notice-message,\n.ant-notification-notice-error .ant-notification-notice-description {\n  color: var(--flexi-error) !important;\n}\n\n.ant-notification-notice .ant-notification-notice-close {\n  color: var(--flexi-grey) !important;\n  top: 5px !important;\n  right: 12px !important;\n}\n\n.ant-notification-notice-icon {\n  font-size: 18px !important;\n  min-width: 18px !important;\n  width: 18px !important;\n  height: 18px !important;\n  line-height: 18px !important;\n}\n\n.ant-notification-notice-closable .ant-notification-notice-message {\n  padding-right: 35px !important;\n}\n\n.ant-notification-notice-success .ant-notification-notice-message,\n.ant-notification-notice-success .ant-notification-notice-description, .ant-message-success  {\n  color: var(--flexi-valid) !important;\n}\n\n.ant-notification-notice {\n  display: inline-block !important;\n  width: auto !important;\n  max-width: 80vw !important;\n  white-space: nowrap !important;\n  min-width: 240px !important;\n}\n\n.ant-notification-notice-with-icon .ant-notification-notice-message, .ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-left: 35px !important;\n}\n\n.ant-notification-top {\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  right: auto !important;\n  top: 24px !important;\n}\n\n.ant-notification-fade-enter, .ant-notification-fade-appear {\n  animation-name: NotificationFadeInDown !important;\n}\n\n@keyframes NotificationFadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-40px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ant-cascader {\n  width: 80%\n}\n\n\n// ANT INPUT NUMBER\n.ant-input-number .ant-input-number-handler-wrap, .ant-input-number-focused .ant-input-number-handler-wrap {\n  opacity: 1;\n}\n\n.ant-input-number-affix-wrapper .ant-input-number-handler-wrap {\n  z-index: 0;\n}\n\n.ant-input-number-sm {\n  width: 75px;\n}\n\n.ant-input-number {\n  width: 70px;\n  border-radius: 2px !important;\n}\n\n.ant-input-prefix {\n  color: var(--flexi-placeholder) !important;\n}\n\n.ant-input {\n  border-radius: 2px !important;\n}\n// CHECKBOX\n.ant-table-filter-dropdown .ant-checkbox-checked, .ant-collapse .ant-checkbox-checked {\n  top: 0;\n\n  .ant-checkbox-inner {\n    position: absolute !important;\n    top: -2px;\n  }\n  \n  .ant-checkbox-input {\n    margin-right: 14px;\n  }\n}\n\n.ant-collapse .checkbox-all-outside .ant-checkbox {\n margin-left: 27px\n}\n\n.ant-tree-draggable-icon {\n  cursor: grab;\n\n    &:active {\n    cursor: grabbing;\n  }\n}\n\n// modal\n.ant-modal-content {\n  border-radius: 20px !important;\n  padding: 30px 10px !important;\n}\n\n.modal-preview-document .ant-modal-content {\n  padding: 0 !important;\n}\n\n.ant-btn-text span, .ant-modal-footer .ant-btn-default span, .ant-popover-buttons .ant-btn-default span {\n  text-decoration: underline !important;\n}\n\n.ant-modal-header {\n  border-bottom: none !important;\n  border-radius: 20px 20px 0 0 !important;\n}\n\n.ant-modal-footer {\n  padding: 0px 24px !important;\n  border-top: none !important;\n}\n\n.ant-modal-title {\n  font-size: 24px !important;\n  font-weight: 700 !important;\n  line-height: 30px !important;\n}\n\n.ant-modal-footer .ant-btn-default, .ant-popover .ant-btn-cancel  {\n  background: none !important;\n  border: none !important;\n  color: var(--flexi-primary-color, #2CB4AD) !important;\n  font-weight: 400 !important;\n  box-shadow: none !important;\n  cursor: pointer;\n}\n\n.ant-popover .ant-btn {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.ant-modal-body {\n    padding-top: 0;\n\n    > p {\n      font-size: 14px;\n      margin-bottom: 30px;\n    }\n\n    > b {\n      font-size: 13px;\n    }\n\n    > .ant-input-affix-wrapper {\n      border-radius: 25px !important;\n      font-weight: bold;\n      font-size: 13px;\n      margin: 7px 0;\n\n      svg {\n        color: var(--flexi-placeholder);\n      }\n    }\n\n  }\n  \n.modal-buttons {\n  margin-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n\n  .ant-btn-text {\n    color: var(--flexi-primary-color);\n  }\n}\n\n.ant-popover-message > .anticon {\n  color: var(--flexi-warning) !important;\n}\n\n.ant-table-tbody .ant-table-cell .anticon {\n  transition: all .3s linear;\n  border-radius: 4px;\n\n  &:hover {\n    background-color: var(--flexi-col-table) !important;\n  }\n}\n\n.ant-tag-custom .ant-tag {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n// ANT TOOLTIP\n.flexi-rich-tooltip {\n  .ant-tooltip-inner {\n    border-radius: 6px;\n    padding: 8px 12px;\n    font-size: 12px;\n    line-height: 18px;\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    font-family: Roboto, sans-serif;\n    white-space: normal;\n    max-width: 450px;\n    min-width: 0;\n  }\n\n  .ant-tooltip-arrow {\n    display: none;\n  }\n\n  ul {\n    margin: 4px 0 0;\n    padding-left: 16px;\n    list-style: disc;\n\n    li {\n      margin: 0;\n      padding: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
